import * as React from "react";
import AsyncAction from "../AsyncAction";

interface ChangePanelProps {
  disabled: boolean;
  actionsOnLeftSide?: Boolean;
  onSave: () => Promise<any>;
  onCancel?: () => void;
  isValid?: boolean;
  buttonId?: string;
}

export default function SavePanel(props: ChangePanelProps) {
  const cancelClick = () => {
    props.onCancel();
  };

  return (
    <div className={props.actionsOnLeftSide ? "save-panel-on-left" : "save-panel"}>
      {props.onCancel && (
        <button
          className={"button-secondary cancel"}
          onClick={cancelClick}
          disabled={props.disabled}
        >
          {i18n["Global.Cancel"]}
        </button>
      )}
      <AsyncAction
        buttonLabel={i18n["Global.Save"]}
        promise={props.onSave}
        disabled={props.disabled || props.isValid === false}
        buttonId={props.buttonId}
      />
    </div>
  );
}
